'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const table_types = require('../table.types.js');
const tableRow = require('../TableRow/table-row.js');

// Create the footer rows as Table Rows
var createFooterRows = function createFooterRows(props) {
  var columnData = props.columnData,
      data = props.data,
      tableIndex = props.tableIndex,
      dark = props.dark;
  var rows = data.map(function (row, i) {
    return /*#__PURE__*/React__default.createElement(tableRow, {
      dark: dark,
      tableIndex: tableIndex,
      data: row,
      columnData: columnData,
      type: table_types.CellTypes.FOOTER,
      key: "footer-row-".concat(i)
    });
  });
  return rows;
};

var TableFooter = function TableFooter(props) {
  var footerRows = createFooterRows(props);
  return /*#__PURE__*/React__default.createElement("tfoot", null, footerRows);
};

module.exports = TableFooter;
